<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toast from '@/components/ui/Toast.vue'
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue'
</script>

<template>
  <RouterView />
  <Toast />
  <ConfirmDialog />
</template>
